<template>
  <div class="c-products-list">
    <f-slider
      v-if="isDesktop && products.length >= 4"
      :slider-items-changed="true"
      class="c-products-slider"
    >
      <f-product-card
        v-for="(product, index) in products"
        v-bind="bindingData(index)"
        :product="product"
        :key="index"
      >
      </f-product-card>
    </f-slider>

    <ul v-else class="c-products-list__list">
      <li
        v-for="(product, index) in productsSpSliced"
        :class="['c-products-list__item', { narrow }]"
        :key="index"
      >
        <f-product-card 
          :narrow="narrow" 
          :product="product" 
          :size="size"
        >
        </f-product-card>
      </li>
    </ul>
  </div>
</template>

<script>
import { isDesktop } from '~/js/templates/index/helpers'
import FProductCard from '~/js/components/productCard'
import FSlider from '~/js/components/slider'

export default {
  name: 'ComponentsProductsList',
  components: {
    FProductCard,
    FSlider,
  },
  props: {
    columnsSp: { type: Number, default: 3 },
    hasLimit: { type: Boolean, default: true },
    isRanking: { type: Boolean, default: false },
    products: { type: Array, default: () => [] },
  },
  computed: {
    narrow() {
      return this.columnsSp > 2
    },
    productsSpSliced() {
      return this.hasLimit
        ? this.products.slice(0, this.columnsSp * 2)
        : this.products
    },
  },
  data() {
    return {
      isDesktop: isDesktop(),
      size: isDesktop() ? undefined : 'small',
    }
  },
  methods: {
    bindingData(index) {
      return this.isRanking ? { rankNumber: index + 1 } : undefined
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/mixins';

.c-products-list {
  &__list {
    display: flex;
    flex-wrap: wrap;
    margin: -12px;
  }

  &__item {
    padding: 12px;
    width: 50%;

    &.narrow {
      width: calc(100% / 3);
    }

    @include mixins.screen-desktop {
      width: 25%;
    }
  }
}
</style>
